import AddressesListAndForm from '../components/AddressesListAndForm';

const CheckoutShippingAddress = () => {
  return <AddressesListAndForm selectIdPrefix="shipping-address" />;
};

export default CheckoutShippingAddress;
